import React from 'react';
import {useDashboardEstimates} from './useDashboardEstimates';
import {EstimatesContainer} from './EstimatesContainer';

export const EstimatesSection = () => {
  const panels = useDashboardEstimates();

  return <EstimatesContainer estimates={panels} />;
};
